// extracted by mini-css-extract-plugin
export var statItem = "_lg-1";
export var statsRow = "_lg-0";